import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  Typography,
  withStyles,
  Tabs,
  Tab,
  Box,
} from '@material-ui/core'
import { Icon } from '@iconify/react'
import styles from './styles'
import RecentFiles from 'src/components/recent-files'
import { CoreButton } from 'src/components/core'
import { useDispatch } from 'react-redux'
import { track } from '@amplitude/analytics-browser'
import { aICreatorUploadAttachmentSuccess, aICreatorAddAttachmentUrlAction } from 'src/reducers/ai-creator/action'
import UserType from 'src/model/user-types'

const TabPanel = props => {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ paddingTop: '16px' }}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  )
}

const AddSourceModal = ({
  classes,
  open,
  onClose,
  handleFileSelect,
  fileInputRef,
  handleOnDropFile,
  attachmentLoading,
}) => {
  const [tabValue, setTabValue] = useState(0)
  const dispatch = useDispatch()
  const [videoUrl, setVideoUrl] = useState('')
  const userRole = UserType[window.CONSTANTS.USER_ROLE_ID]

  const userControl = !(
    UserType.isTrialEquivalent(userRole) ||
    userRole === 'Plus' ||
    userRole === 'Pro v2' ||
    userRole === 'Launch' ||
    userRole === 'Essentials' ||
    userRole === 'Growth' ||
    userRole === 'Elite' ||
    userRole === 'AppSumo (Tier 4)' ||
    userRole === 'AppSumo (Tier 5)' ||
    userRole === 'AppSumo (Tier 6)' ||
    userRole === 'AppSumo (Tier 7)' ||
    userRole === 'AppSumo (Tier 8)' ||
    userRole === 'AppSumo (Tier 9)' ||
    userRole === 'Enterprise' ||
    userRole === 'Scale' ||
    userRole === 'Super Admin'
  )

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const handleRecentFileSelect = item => {
    const fileName = item.attachment_type === 'youtube' || item.attachment_type === 'web'
      ? item.file_url || item.source_url || item.original_file_name || item.file_name
      : item.original_file_name || item.file_name
    dispatch(aICreatorUploadAttachmentSuccess(item, fileName))
    onClose()
  }

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  const handleAddVideo = () => {
    track('upload_attachment', {
      type: 'youtube',
      video_url: videoUrl,
    })

    dispatch(aICreatorAddAttachmentUrlAction({ url: videoUrl, attachment_type: 'youtube' }, (res, err) => {
      if (!err) {
        setVideoUrl('')
        onClose()
      }
    }))
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
    >
      <div className={classes.dialogTitle}>
        <div>
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            Add Source Content
          </Typography>
          <Typography
            variant="body2"
            style={{ color: '#637381', marginTop: '4px' }}
          >
            Choose how you want to add materials.
          </Typography>
        </div>
        <Icon
          icon="iconamoon:close-light"
          className={classes.closeButton}
          width="24"
          height="24"
          onClick={onClose}
        />
      </div>

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        className={classes.tabs}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab
          label={
            <div className={classes.tabLabelContainer}>
              <Icon icon="ph:file-text" style={{ fontSize: '18px' }} />
              Document
            </div>
          }
          className={classes.tab}
          disableRipple
        />
        <Tab
          label={
            <div className={classes.tabLabelContainer}>
              <Icon icon="ph:video-camera" style={{ fontSize: '18px' }} />
              YouTube
            </div>
          }
          className={classes.tab}
          disableRipple
        />
        <Tab
          label={
            <div className={classes.tabLabelContainer}>
              <Icon icon="ph:clock" style={{ fontSize: '18px' }} />
              Recent
            </div>
          }
          className={classes.tab}
          disableRipple
        />
        <Tab
          label={
            <div className={classes.tabLabelContainer}>
              <Icon icon="ph:globe" style={{ fontSize: '18px' }} />
              Web URL
              <span className={classes.soonLabel}>Soon</span>
            </div>
          }
          className={classes.tab}
          disableRipple
          disabled
        />
      </Tabs>

      <DialogContent className={classes.dialogContent}>
        {/* Document Panel */}
        <TabPanel value={tabValue} index={0}>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            accept=".pdf"
            onChange={(e) => {
              handleFileSelect(e);
              onClose();
            }}
          />
          <div
            className={classes.uploadContainer}
            onClick={handleUploadClick}
            onDrop={(e) => {
              handleOnDropFile(e);
              onClose();
            }}
            onDragOver={e => e.preventDefault()}
          >
            <div
              style={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                padding: '16px',
                boxShadow: '0px 4px 12px rgba(0,0,0,0.05)',
                marginBottom: '16px',
                width: '64px',
                height: '64px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Icon icon="ph:file-text" style={{ fontSize: '32px', color: '#015FFB' }} />
            </div>
            <Typography className={classes.uploadTitle}>
              Upload from your device
            </Typography>
            <Typography className={classes.uploadSubtitle}>
              Support for PDF files up to 100MB and max. 100 pages.
            </Typography>
          </div>
        </TabPanel>

        {/* YouTube Panel */}
        <TabPanel value={tabValue} index={1}>
          {!userControl ? (
            <>
              <Typography
                style={{ fontWeight: 600, fontSize: '14px', marginBottom: '8px' }}
              >
                Video Link
              </Typography>
              <Typography
                style={{
                  color: '#637381',
                  fontSize: '12px',
                  marginBottom: '16px',
                }}
              >
                The AI will analyze the transcript of the video to create content.
              </Typography>

              <div className={classes.videoInputContainer}>
                <div className={classes.videoInput}>
                  <Icon icon="ph:video-camera" style={{ color: '#919EAB', fontSize: '20px' }} />
                  <input
                    type="text"
                    placeholder="https://youtube.com/watch?v=..."
                    value={videoUrl}
                    onChange={e => setVideoUrl(e.target.value)}
                  />
                </div>
              </div>

              <CoreButton
                variant="contained"
                color="secondary"
                fullWidth
                disabled={!videoUrl}
                onClick={handleAddVideo}
              >
                Add Video
              </CoreButton>
            </>
          ) : (
            <div className={classes.youtubeUpgradeBanner}>
              <div className={classes.youtubeUpgradeBannerLeft}>
                <Typography className={classes.youtubeUpgradeBannerTitle}>
                  Turn your YouTube videos into structured courses in minutes.
                </Typography>
                <Typography className={classes.youtubeUpgradeBannerDesc}>
                  Upgrade to automatically convert any video into a complete course; AI organizes the content into clear lessons and adds key screenshots for better learning.
                </Typography>
                <button
                  className={classes.youtubeUpgradeBannerButton}
                  onClick={() => { window.location.href = '/pricing' }}
                >
                  See Plans & Upgrade
                </button>
              </div>
              <div className={classes.youtubeUpgradeBannerRight}>
                <img
                  src="/assets/ai-img-presets/youtube-banner-img.png"
                  alt="Upgrade"
                  className={classes.youtubeUpgradeBannerImage}
                />
              </div>
            </div>
          )}
        </TabPanel>

        {/* Recent Panel */}
        <TabPanel value={tabValue} index={2}>
          <RecentFiles selectRecentFiles={handleRecentFileSelect} />
        </TabPanel>

        {/* Web URL Panel */}
        <TabPanel value={tabValue} index={3}>
          <div style={{ padding: '40px 20px', textAlign: 'center', color: '#637381' }}>
            <Icon icon="ph:globe" width="48" height="48" style={{ marginBottom: '16px', opacity: 0.5 }} />
            <Typography style={{ fontWeight: 500 }}>Web URL parsing coming soon!</Typography>
          </div>
        </TabPanel>

      </DialogContent>
    </Dialog>
  )
}

export default withStyles(styles)(AddSourceModal)
